import globals from "./globals";
import { getBool } from "utilities";
import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        var target = $("#menu-button");

        if (target.length) {
            if (globals.debug) console.log("event-menu-toggle initialized");

            target.on("click", function () {
                var toggleState = getBool(target.attr("data-toggle"));
                var event = toggleState ? "menuClose" : "menuOpen";

                window.dispatchEvent(new CustomEvent(event));
                window.dispatchEvent(new CustomEvent("menuToggle"));
            });
        }
    });
})();

export default component;
